import React from 'react';
import { Json } from './json';
import { ToastManager, TOAST_TYPES } from '../fasades/toastmanager';
import { IoMdCopy } from 'react-icons/io';
import './apiexamplecode.css';

interface Props {
    output: object[];
    title?: string;
}

export class ApiExampleOutput extends React.Component<Props> {
    handleCopyCode() {
        const outputString = JSON.stringify(this.props.output, null, 2);
        navigator.clipboard.writeText(outputString)
            .then(() => ToastManager.addToast('Output copied to clipboard!', TOAST_TYPES.SUCCESS, 3000))
            .catch(() => ToastManager.addToast('Failed to copy output', TOAST_TYPES.ERROR, 3000));
    }

    render() {
        return (
            <div className="api-example-code">
                <div className="example-header-bar">
                    <h3 className="example-title">
                        {`Response ${this.props.title}`}
                    </h3>
                    <button
                        type="button"
                        className="copy-button"
                        onClick={() => { this.handleCopyCode() }}
                        title="Copy to clipboard"
                    >
                        {React.createElement(IoMdCopy as React.ComponentType)}
                    </button>
                </div>
                <div className="example-section">
                  <pre className="code-block">
                    <code>
                    {this.props.output.map((chunk, index) => {
                        // Check if this is a truncation marker
                        if (typeof chunk === 'object' && chunk !== null && '_truncated' in chunk && (chunk as any)._truncated === true) {
                            return (
                                <span key={index}>{ "\n ... \n\n" }</span>
                            );
                        }
                        return <Json key={index} value={chunk} expandTo={10} />;
                    })}
                    </code>
                  </pre>
                </div>
            </div>
        );
    }
}

